import useSWR from 'swr';

import app from "../base";


const useReportsForDealerByVIN = (dealerId, searchInput) => {
    const { data, error, mutate } = useSWR(
        dealerId && (searchInput.length > 3)
            ? [
                `/reports/dealerships/${dealerId}?limit=99999&search=${searchInput}`,
                /* options */ undefined,
                app.auth().currentUser.uid
            ]
            : null
    );

    return {
        reportsByVin: data,
        isLoadingUser: !error && !data,
        isError: error,
        mutateReports: mutate,
    }
};

export default useReportsForDealerByVIN;
